import pluralize from "pluralize";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { SectionTitle } from '@blueprint/ui';

import { FileRow } from "../../../common/components";
import { BankAccount } from "../../../types/common";
import { formatAmount } from "../../../utils/amount";
import { formatToDate } from "../../../utils/common";

import { InvoiceFormValues } from "./InvoiceForm";

type InvoicePreviewProps = {
    formValues: InvoiceFormValues;
    bankAccountList: BankAccount[];
};

const InvoicePreview = ({
    formValues,
    bankAccountList,
}: InvoicePreviewProps): JSX.Element => {

    const selectedBankAccount = bankAccountList.find((it) =>
        (it.bankAccountHolderName + "-" + it.bankAccountNumber) === formValues?.bankAccount
    );

    return (
        <Card className="mb-3 border-0">
            <Card.Header className="px-0 py-2">
                <h2 className="mb-0">Invoice Submission</h2>
            </Card.Header>
            <Card.Body className="px-0 py-3">
                <dl>
                    <div>
                        <SectionTitle className="mb-3" variant="h3">Beneficiary Details</SectionTitle>
                        <dd>
                            <p className="mb-2">
                                <span className="h1">
                                    {formatAmount(formValues.amount)}
                                </span>
                                <span className="ms-2 fw-bold">
                                    {formValues.currency}
                                </span>
                            </p>
                        </dd>
                        <dt>
                            <p className="text-label-grey mb-5">Requested Amount</p>
                        </dt>
                    </div>
                    <hr className="bg-border-grey my-2" />
                    <Row xs={5}>
                        <Col className="border-end  border-humble-grey">
                            <dt>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Creation Date
                                </p>
                            </dt>
                            <dd>
                                <p className="fw-bold">
                                    {formatToDate(
                                        formValues.createdAt ??
                                            new Date().toISOString(),
                                    )}
                                </p>
                            </dd>
                        </Col>
                        <Col className="px-4 border-end  border-humble-grey">
                            <dt>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Beneficiary Name
                                </p>
                            </dt>
                            <dd>
                                <p className="fw-bold mb-0">
                                    {selectedBankAccount?.bankAccountHolderName}
                                </p>
                            </dd>
                        </Col>
                        <Col className="px-4 border-end  border-humble-grey">
                            <dt>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Beneficiary Bank Account
                                </p>
                            </dt>
                            <dd>
                                <p className="fw-bold">
                                    {selectedBankAccount?.bankAccountNumber}
                                </p>
                            </dd>
                        </Col>
                        <Col className="px-4 border-end border-humble-grey">
                            <dt>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Beneficiary Bank
                                </p>
                            </dt>
                            <dd>
                                <p className="fw-bold">
                                    {selectedBankAccount?.swiftAddress} -{" "}
                                    {selectedBankAccount?.bankName}
                                </p>
                            </dd>
                        </Col>
                        <Col className="px-4">
                            <dt>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Beneficiary Address
                                </p>
                            </dt>
                            <dd>
                                <p className="fw-bold">
                                    {selectedBankAccount?.registeredAddress}
                                </p>
                            </dd>
                        </Col>
                    </Row>
                    <hr className="bg-border-grey my-2" />
                    <SectionTitle className="mb-3 mt-5" variant="h3">{pluralize("Invoices", formValues.files.length)}</SectionTitle>
                    {formValues.files.map((file, index) => (
                        <FileRow key={index} file={file} />
                    ))}
                </dl>
            </Card.Body>
        </Card>

    );
};

export default InvoicePreview;
